<template>
  <div v-loading="loading">
    <div class="content-box">
      <validation-observer ref="formValidator">
        <div class="section-box outline">
          <div class="das-form-container">
            <div class="das-form-group">
              <div class="das-form-group-title">Thông tin người đặt</div>
              <div class="das-form-row">
                <div class="das-form-col col-6">
                  <div class="">
                    <div class="label das-label das-label--required">
                      {{ $t('field.fullName') }}
                    </div>
                    <div class="das-layout gap-10">
                      <div style="width: 25%">
                        <!-- -->
                        <el-select
                          v-model="bookerFormData.name"
                          :disabled="isBookerSelected"
                          placeholder="Danh xưng"
                        >
                          <el-option
                            v-for="item in titleOptions"
                            :key="`customer-title-${item.value}`"
                            :label="item.label"
                            :value="item.value"
                          >
                          </el-option>
                        </el-select>
                      </div>
                      <div style="width: 75%">
                        <div>
                          <el-row :gutter="8">
                            <el-col :span="10">
                              <validation-provider
                                :name="$t('field.firstName')"
                                rules=""
                              >
                                <input
                                  v-model="bookerFormData.last_name"
                                  :disabled="isBookerSelected"
                                  type="text"
                                  placeholder="Họ"
                                />
                              </validation-provider>
                            </el-col>
                            <el-col :span="14">
                              <div class="input-group">
                                <validation-provider
                                  :name="$t('field.lastName')"
                                  rules="required"
                                >
                                  <input
                                    v-model="bookerFormData.first_name"
                                    :disabled="isBookerSelected"
                                    type="text"
                                    placeholder="Tên"
                                  />
                                </validation-provider>
                                <div
                                  class="input-group__append input-group-btn"
                                >
                                  <button
                                    :disabled="action != 'create'"
                                    @click="onRemoveBooker"
                                  >
                                    <!-- -->
                                    <i class="el-icon-delete"></i>
                                  </button>

                                  <button
                                    :disabled="action != 'create'"
                                    @click="onOpenSelectBookerDialog"
                                  >
                                    <i class="el-icon-search"></i>
                                  </button>
                                </div>
                              </div>
                            </el-col>
                          </el-row>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="das-form-col col-3">
                  <div class="">
                    <div class="label required">
                      {{ $t('field.phoneNumber') }}
                    </div>

                    <el-row>
                      <div class="input-group">
                        <div class="input-group">
                          <!-- <input
                      v-model="bookerFormData.phone"
                      v-numeric-only
                      type="number"
                      placeholder="Nhập số điện thoại"
                      required
                    /> -->

                          <vue-tel-input
                            v-model="bookerFormData.phone"
                            v-numeric-only
                            :disabled="isBookerSelected"
                            default-country="VN"
                            :input-options="{
                              showDialCode: true,
                              placeholder: 'Số điện thoại'
                            }"
                            @country-changed="onCountryChanged"
                          />
                          <div class="input-group__append input-group-btn">
                            <button @click="onSearchDuplicateCustomer">
                              Kiểm tra
                            </button>
                            <!-- -->
                          </div>
                        </div>
                      </div>
                    </el-row>
                  </div>
                </div>
                <div class="das-form-col col-3">
                  <div class="">
                    <div class="label">
                      {{ $t('field.email') }}
                    </div>
                    <validation-provider
                      :name="$t('field.email')"
                      rules="email"
                    >
                      <!--
                        :disabled="isBookerSelected" -->
                      <input
                        v-model="bookerFormData.email"
                        :disabled="isBookerSelected"
                        type="text"
                      />
                    </validation-provider>
                  </div>
                </div>
              </div>
            </div>
            <div class="das-form-group">
              <!-- group -->
              <div class="das-form-group-title">Thông tin chung</div>
              <!-- Row -->
              <div class="das-form-row">
                <div class="das-form-col col-3">
                  <div class="das-form-input">
                    <div class="label required">
                      {{ $t('field.nameGroup') }}
                    </div>
                    <div class="child-w-80">
                      <div
                        style="display: flex; gap: 10px; align-items: center"
                      >
                        <validation-provider
                          rules="required|max:50"
                          :name="$t('field.nameGroup')"
                          style="width: 100%"
                        >
                          <input
                            v-model="form.name"
                            type="text"
                            :placeholder="$t('field.nameGroup')"
                          />
                          <!-- @keypress="clsAlphaNoOnly" -->
                        </validation-provider>
                        <validation-provider
                          rules=""
                          :name="$t('field.colorCode')"
                        >
                          <el-color-picker
                            v-model="form.color"
                            :color-format="'hex'"
                            @active-change="changeColor"
                          />
                        </validation-provider>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="das-form-col col-3">
                  <div class="das-form-input">
                    <div class="label required">
                      {{ $t('field.firstArriveDate') }}
                    </div>
                    <validation-provider
                      rules="required"
                      :name="$t('field.firstArriveDate')"
                    >
                      <div class="child-w-80">
                        <!-- <SingleCalendar
                          v-model="form.first_arrival_date"
                          class="use-icon"
                          :date-data="form.first_arrival_date"
                          @input="changeCalendarArrival"
                        /> -->
                        <CalendarSelect
                          v-model="form.first_arrival_date"
                          style="display: block; width: 100%"
                          mode="date"
                          :min-max="{
                            min: this.$moment()
                              .startOf('day')
                              .format('YYYY-MM-DD')
                          }"
                          @input="onChangeDateFrom"
                        />
                      </div>
                    </validation-provider>
                  </div>
                </div>
                <div class="das-form-col col-3">
                  <div class="das-form-input">
                    <div class="label required">
                      {{ $t('field.lastDepartureDate') }}
                    </div>
                    <validation-provider
                      rules="required"
                      :name="$t('field.lastDepartureDate')"
                    >
                      <div class="child-w-80">
                        <!-- <SingleCalendar
                          v-model="form.last_departure_date"
                          class="use-icon"
                          :date-data="form.last_departure_date"
                          @input="changeCalendarDeparture"
                        /> -->
                        <CalendarSelect
                          v-model="form.last_departure_date"
                          style="display: block; width: 100%"
                          mode="date"
                          :min-max="{
                            min: this.$moment()
                              .startOf('day')
                              .format('YYYY-MM-DD')
                          }"
                          @input="onChangeDateTo"
                        />
                      </div>
                    </validation-provider>
                  </div>
                </div>
                <div class="das-form-col col-3">
                  <div class="das-form-input">
                    <div class="label required">
                      {{ $t('field.numberNight') }}
                    </div>
                    <validation-provider
                      rules="required"
                      :name="$t('field.numberNight')"
                    >
                      <div class="child-w-80">
                        <input
                          v-model="form.numb_of_night"
                          disabled
                          type="number"
                          min="0"
                          :placeholder="$t('field.numberNight')"
                        />
                      </div>
                    </validation-provider>
                  </div>
                </div>
              </div>
              <!-- Row -->
              <div class="das-form-row">
                <!-- col -->
                <div class="das-form-col col-6">
                  <div class="das-form-input">
                    <div class="label">{{ $t('field.note') }}</div>
                    <validation-provider
                      rules="max:200"
                      :name="$t('field.note')"
                    >
                      <div class="child-w-80">
                        <textarea
                          v-model="form.note"
                          :disabled="
                            action === 'edit' &&
                            !bookingRecord?.is_able_update_note
                          "
                          :placeholder="$t('field.note')"
                          style="width: 100%"
                          rows="4"
                        />
                      </div>
                    </validation-provider>
                  </div>
                </div>
                <div class="das-form-col col-3">
                  <div class="das-form-input">
                    <div class="label">Trạng thái đặt phòng</div>

                    <div class="child-w-80">
                      <el-select v-model="form.status">
                        <el-option :value="1" label="Definite"></el-option>
                        <el-option :value="2" label="Tentative"></el-option>
                      </el-select>
                    </div>
                  </div>
                </div>
              </div>
              <!-- Row -->
            </div>
            <hr />
            <div class="das-form-group">
              <!-- group -->
              <div class="das-form-group-title">Thống kê</div>
              <!-- Row -->
              <div class="das-form-row">
                <!-- col -->
                <div class="das-form-col col-3">
                  <div class="das-form-input">
                    <div class="label">
                      {{ $t('field.companyAgent') }}
                      <span
                        class=""
                        style="
                          text-decoration: underline;
                          color: #357456;
                          font-size: 12px;
                          cursor: pointer;
                        "
                        @click="openRegisAgent"
                      >
                        {{ '   ' }} tạo mới
                      </span>
                    </div>
                    <validation-provider
                      rules=""
                      :name="$t('field.companyAgent')"
                    >
                      <div class="child-w-80">
                        <select-with-search-table
                          style="width: 100%"
                          :rows="agentOptions"
                          :columns="columnsAgent"
                          index-field="id"
                          :dropdown-width="600"
                          :is-remove-btn="true"
                          :selected-index-field-value="form.agent_id"
                          :value="form.agent_id"
                          @selectionChanged="onSelectRowAgent"
                        >
                          <template
                            v-slot:value="{ selectedValue: selectedData }"
                          >
                            {{ selectedData?.name }}
                          </template>
                        </select-with-search-table>
                      </div>
                    </validation-provider>
                  </div>
                </div>
                <div class="das-form-col col-3">
                  <div class="das-form-input">
                    <div class="label">{{ $t('field.debitAccount') }}</div>
                    <div class="child-w-80">
                      <el-select
                        v-model="form.debit_account_id"
                        :disabled="!form?.agent_id"
                      >
                        <el-option
                          v-for="(debit, index) in debitAccountOptions"
                          :key="index"
                          :value="debit.id"
                          :label="debit.name"
                        ></el-option>
                      </el-select>
                      <!-- <select-with-search-table
                        style="width: 100%"
                        :rows="debitAccountOptions"
                        :columns="columnsDebitAccount"
                        index-field="id"
                        :dropdown-width="400"
                        :disabled="!form?.agent_id"
                        :selected-index-field-value="form.debit_account_id"
                        :value="form.debit_account_id"
                        @selectionChanged="onSelectDebitAccount"
                      >
                        <template
                          v-slot:value="{ selectedValue: selectedData }"
                        >
                          {{ selectedData?.name }}
                        </template>
                      </select-with-search-table> -->
                    </div>
                  </div>
                </div>
                <div class="das-form-col col-3">
                  <div class="das-form-input">
                    <div class="label">{{ $t('field.marketSegment') }}</div>
                    <div class="child-w-80">
                      <el-select
                        v-model="form.market_seg_id"
                        placeholder="Vui lòng chọn"
                        clearable
                        filterable
                      >
                        <el-option
                          v-for="item in marketSegmentOptions"
                          :key="item.id"
                          :label="item.desc"
                          :value="item.id"
                        >
                        </el-option>
                      </el-select>
                    </div>
                  </div>
                </div>
                <div class="das-form-col col-3">
                  <div class="das-form-input">
                    <div class="label required">{{ $t('field.source') }}</div>
                    <div class="child-w-80">
                      <validation-provider
                        rules="required"
                        :name="$t('field.source')"
                      >
                        <select-with-search-table
                          style="width: 100%"
                          :rows="sourceOptions"
                          :columns="columnsSource"
                          :dropdown-width="400"
                          :is-remove-btn="true"
                          index-field="id"
                          :selected-index-field-value="form.source_id"
                          :value="form.source_id"
                          @selectionChanged="onSelectRowSource"
                        >
                          <template
                            v-slot:value="{ selectedValue: selectedData }"
                          >
                            {{ selectedData?.desc }}
                          </template>
                        </select-with-search-table>
                      </validation-provider>

                      <!-- <input v-model="sourceCode" disabled type="text" /> -->
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <hr />
            <div class="das-form-group">
              <!-- group -->
              <div class="das-form-group-title">Giá & Thông tin thanh toán</div>
              <!-- Row -->
              <div class="das-form-row">
                <!-- col -->

                <div class="das-form-col col-3">
                  <div class="das-form-input">
                    <div class="label">{{ $t('field.payMethod') }}</div>
                    <div class="child-w-80">
                      <!-- placeholder="Chọn phương thức"+ -->
                      <el-select
                        v-model="form.pay_method"
                        style="flex: 1"
                        placeholder="Chọn"
                      >
                        <el-option
                          v-for="(item, index) in payMethodList"
                          :key="index"
                          :label="item.name"
                          :value="item.value"
                        >
                        </el-option>
                      </el-select>
                      <!-- <select v-model="form.pay_method">
                        <option
                          v-for="(item, index) in payMethodList"
                          :key="index"
                          :value="item.value"
                        >
                          {{ item.name }}
                        </option>
                      </select> -->
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <hr />
            <div class="das-form-group">
              <!-- group -->
              <div class="das-form-group-title">Thông tin khác</div>
              <!-- Code Thông tin phương tiện mới -->
              <div class="das-form-row">
                <div
                  class="grid-scroll mt-10"
                  style="
                    height: calc(40px + 5 * 34px);
                    width: 100%;
                    overflow: visible;
                  "
                >
                  <GridVx
                    ref="vehicleGrid"
                    class="agGrid"
                    :columns="vehicleCols"
                    :rows="vehicles"
                    :context="context"
                    :auto-select-first-row="false"
                    :auto-size-cell="true"
                    dom-layout="scroll"
                    style="overflow: visible"
                  />
                </div>
              </div>
              <!-- <div class="das-form-row">
                <div class="das-form-col col-3">
                  <div class="das-form-input">
                    <div class="label">{{ 'Phương tiện' }}</div>
                    <validation-provider
                      rules="max:50"
                      :name="$t('Phương tiện')"
                    >
                      <div class="child-w-80">
                        <input v-model="form.vehicle" type="text" />
                      </div>
                    </validation-provider>
                  </div>
                </div>
                <div class="das-form-col col-3">
                  <div class="das-form-input">
                    <div class="label">{{ $t('field.arrivingTime') }}</div>
                    <div class="child-w-80">
                      <CalendarSelect
                        v-model="form.arriving_time"
                        style="display: block; width: 100%"
                        mode="datetime"
                        :min-max="{
                          min: this.$moment()
                            .startOf('day')
                            .format('YYYY-MM-DD')
                        }"
                      />
                    </div>
                  </div>
                </div>
                <div class="das-form-col col-3">
                  <div class="das-form-input">
                    <div class="label">{{ $t('field.leavingTime') }}</div>
                    <div class="child-w-80">
                      <CalendarSelect
                        v-model="form.leaving_time"
                        style="display: block; width: 100%"
                        mode="datetime"
                        :min-max="{
                          min: this.$moment()
                            .startOf('day')
                            .format('YYYY-MM-DD')
                        }"
                      />
                    </div>
                  </div>
                </div>
              </div> -->
            </div>
          </div>
        </div>
        <!-- Section -->
        <!-- <validation-observer ref="contactFormValidator"> -->
        <div class="contact-address">
          <div class="section-box outline">
            <div class="das-form-container">
              <div class="das-form-title-container justify-space-between">
                <div class="das-form-title">
                  <span class="main-title">số liên hệ 1</span>
                </div>
              </div>
              <hr />
              <div class="das-form-group">
                <!-- group -->
                <div class="das-form-group-title">Người đại diện 1</div>
                <!-- Row -->
                <div class="das-form-row">
                  <!-- col -->
                  <div class="das-form-col col-12">
                    <div class="das-form-input">
                      <div class="label">
                        {{ $t('field.representPerson') }}
                      </div>
                      <validation-provider
                        rules="max:50"
                        :name="'Số liên hệ 1: ' + $t('field.representPerson')"
                        vid="contact1.fullname"
                      >
                        <div class="child-w-80">
                          <input v-model="contact1.fullname" type="text" />
                        </div>
                      </validation-provider>
                    </div>
                  </div>
                </div>
                <div class="das-form-row">
                  <div class="das-form-col col-12">
                    <div class="das-form-input">
                      <div class="label">{{ $t('field.email') }}</div>
                      <validation-provider
                        rules="email"
                        :name="'Số liên hệ 1: ' + $t('field.email')"
                        vid="contact1.email"
                      >
                        <div class="child-w-80">
                          <input v-model="contact1.email" type="text" />
                        </div>
                      </validation-provider>
                    </div>
                  </div>
                </div>
                <div class="das-form-row">
                  <div class="das-form-col col-12">
                    <div class="das-form-input">
                      <div class="label">{{ $t('field.address_1') }}</div>
                      <validation-provider
                        rules="max:100"
                        :name="'Số liên hệ 1: ' + $t('field.address_1')"
                        vid="contact1.address_1"
                      >
                        <div class="child-w-80">
                          <input v-model="contact1.address_1" type="text" />
                        </div>
                      </validation-provider>
                    </div>
                  </div>
                </div>
                <div class="das-form-row">
                  <div class="das-form-col col-12">
                    <div class="das-form-input">
                      <div class="label">{{ $t('field.phoneNumber') }}</div>
                      <validation-provider
                        rules="phone"
                        :name="'Số liên hệ 1: ' + $t('field.phoneNumber')"
                        vid="contact1.phone_number"
                      >
                        <input
                          v-model="contact1.phone_number"
                          onkeypress="return  event.charCode >= 48 && event.charCode <= 57"
                          type="text"
                        />
                      </validation-provider>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="section-box outline">
            <div class="das-form-container">
              <div class="das-form-title-container justify-space-between">
                <div class="das-form-title">
                  <span class="main-title">số liên hệ 2</span>
                </div>
              </div>
              <hr />
              <div class="das-form-group">
                <!-- group -->
                <div class="das-form-group-title">Người đại diện 2</div>
                <!-- Row -->
                <div class="das-form-row">
                  <!-- col -->
                  <div class="das-form-col col-12">
                    <div class="das-form-input">
                      <div class="label">
                        {{ $t('field.representPerson') }}
                      </div>
                      <validation-provider
                        rules="max:50"
                        :name="'Số liên hệ 2: ' + $t('field.representPerson')"
                        vid="contact2.fullname"
                      >
                        <div class="child-w-80">
                          <input v-model="contact2.fullname" type="text" />
                        </div>
                      </validation-provider>
                    </div>
                  </div>
                </div>
                <div class="das-form-row">
                  <div class="das-form-col col-12">
                    <div class="das-form-input">
                      <div class="label">{{ $t('field.email') }}</div>
                      <div class="child-w-80">
                        <validation-provider
                          rules="email"
                          :name="'Số liên hệ 2: ' + $t('field.email')"
                          vid="contact2.email"
                        >
                          <input v-model="contact2.email" type="text" />
                        </validation-provider>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="das-form-row">
                  <div class="das-form-col col-12">
                    <div class="das-form-input">
                      <div class="label">{{ $t('field.address_1') }}</div>
                      <validation-provider
                        rules="max:100"
                        :name="'Số liên hệ 2: ' + $t('field.address_1')"
                        vid="contact2.address_1"
                      >
                        <div class="child-w-80">
                          <input v-model="contact2.address_1" type="text" />
                        </div>
                      </validation-provider>
                    </div>
                  </div>
                </div>
                <!-- <div class="das-form-row">
                  <div class="das-form-col col-12">
                    <div class="das-form-input">
                      <div class="label">{{ $t('field.address_line_2') }}</div>
                      <div class="child-w-80">
                        <input v-model="contact2.address_2" type="text" />
                      </div>
                    </div>
                  </div>
                </div>
                <div class="das-form-row">
                  <div class="das-form-col col-12">
                    <div class="das-form-input">
                      <div class="label">{{ $t('field.fax') }}</div>
                      <input v-model="contact2.fax" type="text" />
                    </div>
                  </div>
                </div> -->
                <div class="das-form-row">
                  <div class="das-form-col col-12">
                    <div class="das-form-input">
                      <div class="label">{{ $t('field.phoneNumber') }}</div>
                      <validation-provider
                        rules="phone"
                        :name="'Số liên hệ 2: ' + $t('field.phoneNumber')"
                        vid="contact2.phone_number"
                      >
                        <input
                          v-model="contact2.phone_number"
                          type="text"
                          onkeypress="return  event.charCode >= 48 && event.charCode <= 57"
                        />
                      </validation-provider>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="section-box outline comments-scroll">
            <div class="das-form-container">
              <div class="das-form-title-container justify-space-between">
                <div class="das-form-title">
                  <span class="main-title">Bình luận</span>
                </div>
              </div>
              <hr />
              <div class="das-form-group">
                <!-- group -->
                <!-- Row -->
                <validation-observer ref="commentFormValidator">
                  <div class="das-form-row">
                    <!-- col -->
                    <div class="das-form-col col-12">
                      <div class="das-form-input">
                        <validation-provider
                          rules="max:100"
                          :name="$t('field.addComment')"
                          vid="commentContent"
                        >
                          <div class="child-w-80 input-comment">
                            <input
                              v-model="commentContent"
                              type="text"
                              :placeholder="$t('field.addComment')"
                            />

                            <!-- @click="dialogVisible1 = true" -->
                            <span class="input-plus-icon" @click="addComment">
                            </span>
                          </div>
                        </validation-provider>
                        <!-- { id: 0, content: '', create_date: '', create_user_id: 0 } -->
                        <div
                          v-for="(commentItem, index) in form.comment"
                          :key="index"
                          class="child-w-80 comment-container"
                        >
                          <p>
                            {{
                              $moment(commentItem.create_date).format(
                                'DD-MM-YYYY'
                              )
                            }}
                          </p>
                          <div class="das-form-input comment-content">
                            <p>{{ username }}:</p>
                            <input
                              v-if="commentItem.isEdit"
                              v-model="commentItem.content"
                              v-focus
                              @blur="
                                commentItem.isEdit = false
                                $emit('update')
                              "
                              @keyup.enter="
                                commentItem.isEdit = false
                                $emit('update')
                              "
                            />
                            <p v-else>
                              {{ commentItem.content }}
                            </p>
                          </div>
                          <span
                            class="input-pen-icon"
                            @click="commentItem.isEdit = true"
                          >
                          </span>
                          <span
                            class="input-delete-icon"
                            @click="deleteComment(index)"
                          >
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>
                </validation-observer>
              </div>
            </div>
          </div>
        </div>
        <!-- </validation-observer> -->
        <div v-if="action === 'create'" class="section-box outline">
          <div class="das-form-container">
            <div class="das-form-title-container">
              <div class="das-form-title">
                <span class="main-title title-required">Đoàn phụ</span>
              </div>
            </div>
          </div>
          <div style="height: 400px" class="grid-scroll mt-10">
            <GridVx
              v-if="rows.length !== 0"
              ref="agGrid"
              style="height: 400px"
              :auto-size-cell="true"
              dom-layout="scroll"
              :columns="columns"
              :rows="rows"
              :context="context"
              class="agGrid room-list"
            />
            <!-- @selectionChanged="onSelectSubGroup" -->
          </div>
        </div>
      </validation-observer>
    </div>
    <!--  -->
    <el-dialog
      :title="$t('field.titleAssignTraveller')"
      :visible.sync="dialogVisible1"
      :close-on-click-modal="false"
      width="80%"
    >
      <!-- <div class="content-container p-0"> -->
      <div class="content-box">
        <div class="section-box">
          <div class="das-form-container">
            <div class="das-form-group">
              <search-comp @onSearch="getTraveller" @onReset="onReset">
                <div class="das-form-row">
                  <!-- col -->
                  <div class="das-form-col col-4">
                    <div class="das-form-input">
                      <div class="label">Thông tin khách</div>
                      <input
                        v-model="searchParamsAccount.name"
                        type="text"
                        placeholder="Họ, tên, Mã hồ sơ"
                      />
                    </div>
                  </div>
                  <div class="das-form-col col-4">
                    <div class="das-form-input">
                      <div class="label">Địa chỉ</div>
                      <input
                        v-model="searchParamsAccount.address"
                        type="text"
                      />
                    </div>
                  </div>
                  <div class="das-form-col col-4">
                    <div class="das-form-input">
                      <div class="label">Quốc tịch</div>
                      <!-- <input
                        v-model="searchParamsAccount.nationId"
                        type="text"
                      /> -->
                      <div class="child-w-80">
                        <select-with-search-table
                          style="width: 100%"
                          :search-fields="['code', 'desc']"
                          index-field="id"
                          :selected-index-field-value="
                            searchParamsAccount.nationId
                          "
                          :columns="nationalityCols"
                          :rows="nationalityRows"
                          :value="searchParamsAccount.nationId"
                          :dropdown-width="400"
                          :is-remove-btn="true"
                          @selectionChanged="onSelectNation"
                        >
                          <template
                            v-slot:value="{ selectedValue: selectedData1 }"
                          >
                            <div>
                              <span>
                                {{
                                  `${selectedData1?.code || ''} - ${
                                    selectedData1?.desc || ''
                                  }`
                                }}
                              </span>
                            </div>
                          </template>
                        </select-with-search-table>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="das-form-row">
                  <!-- col -->
                  <div class="das-form-col col-4">
                    <div class="das-form-input">
                      <div class="label">Hộ chiếu/Thẻ căn cước</div>
                      <input
                        v-model="searchParamsAccount.idCardOrVisa"
                        type="text"
                      />
                    </div>
                  </div>
                  <div class="das-form-col col-4">
                    <div class="das-form-input">
                      <div class="label">Email</div>
                      <input v-model="searchParamsAccount.email" type="text" />
                    </div>
                  </div>
                  <div class="das-form-col col-4">
                    <div class="das-form-input" style="">
                      <div class="label">Số điện thoại</div>
                      <input
                        v-model="searchParamsAccount.phoneNumber"
                        v-numeric-only
                        type="number"
                      />
                    </div>
                  </div>
                </div>
              </search-comp>
              <div class="grid-scroll mt-10">
                <GridVx
                  ref="agGridProfile"
                  :columns="columnsTraveller"
                  :rows="rowsTraveller"
                  class="agGrid"
                  :auto-size-cell="true"
                  :auto-select-first-row="false"
                  @rowClicked="onClickRowTraveller"
                />
              </div>
              <div class="grid-bottom">
                <GridPaging
                  target="agGridProfile"
                  :total-size="totalPage"
                  :page-num="currentPage"
                  :page-size="searchParamsAccount.pageSize"
                  @pageChanged="onPageChanged"
                  @onPageSizeChange="onPageSizeChange"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- </div> -->
      <span
        slot="footer"
        class="dialog-footer"
        style="display: flex; gap: 10px; justify-content: flex-end"
      >
        <button class="btn primary small" @click="addProfileTraveller">
          Thêm hồ sơ
        </button>
        <button
          class="btn primary small"
          :disabled="!isSelectRowProfile"
          @click="assignProfile"
        >
          Gán hồ sơ
        </button>
        <button
          class="btn primary small outline"
          @click="dialogVisible1 = false"
        >
          Hủy
        </button>
      </span>
    </el-dialog>

    <el-dialog
      :visible.sync="isCustomerProfileDialogOpened"
      title="Thông tin khách hàng"
      @close="isCustomerProfileDialogOpened = false"
    >
      <CustomerInfoDialog
        :customer-record="duplicateCustomer"
      ></CustomerInfoDialog>
      <div slot="footer" class="dialog-footer">
        <div class="button-containers">
          <button
            class="btn primary small outline"
            @click="onSelectDuplicateCustomer"
          >
            Lựa chọn
          </button>
          <button
            class="btn primary small"
            @click="isCustomerProfileDialogOpened = false"
          >
            Đóng
          </button>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
/* eslint-disable */
import moment from 'moment'
import CustomerInfoDialog from '@/components/resources/customer/CustomerInfoDialog.vue'

import SelectWithSearchTable from '@/components/inputs/SelectWithSearchTable.vue'
import {
  CellRenderDeleteIcon,
  CellRenderTextInput,
  CellRenderTextInput2,
  CellRenderDateTimeInput,
  CellHeaderAddIcon
} from '@/utils/cellRenders.js'
import Breadcrumb from '@/components/Breadcrumb'
import {
  getTravellerListApi,
  addTravellerApi
} from '@/api/configuration/profile/traveller'
import { getAllNationality } from '../configuration/profile/commonApiCall'
import SingleCalendar from '@/components/ui/SingleCalendar.vue'
import CalendarSelect from '@/components/CalendarSelect/CalendarSelect.vue'
// import { getListAgentApi } from '@/api/configuration/profile/agent.js'
import { getCurrencyListSimpleApi } from '@/api/common/currency'
import {
  getRoomAvaiSubGroupApi,
  getPriceCodeApi,
  addGroupApi,
  getConfirmCodeApi,
  getRoomRowApi
} from '@/api/booking_service/bookingGroup'
import { getUserApi } from '@/api/userConfig/user'
import { getMarketSegmentApi } from '@/api/Statistics/marketSegment'
import { getBreakfastCodeListApi } from '@/api/Service_Policy/breakfastCode'
import { getSourceApi } from '@/api/Statistics/source'
import { notifyError, notifySuccess } from '@/utils/toast'

import { getDebitAccByAgent, getAgent } from '@/api/reception/common.js'
import {
  CellRenderNumInput,
  CellRenderCheckboxReadonly,
  CellRenderCheckbox,
  CellRenderSelect,
  CellRenderCalendar,
  CellRenderCurrencyInput,
  CellRenderCalendarSelect,
  CellRenderCalendarSelectForTable
} from '@/utils/groupCellRenders.js'
import { findDuplicateTraveller } from '@/api/configuration/profile/traveller'
import SpecialServiceDialog from './components/SpecialServiceDialog.vue'
import { getUserDetailApi } from '@/api/profile/profile'
import { getListAgentApi } from '@/api/configuration/profile/agent'
export default {
  components: {
    Breadcrumb,
    SingleCalendar,
    CalendarSelect,
    CellRenderNumInput,
    CellRenderTextInput,
    CellRenderTextInput2,
    SelectWithSearchTable,
    CellRenderCheckboxReadonly,
    CellRenderCheckbox,
    CellRenderSelect,
    CellRenderCalendar,
    CellRenderCalendarSelect,
    CellRenderCurrencyInput,
    CellRenderCalendarSelectForTable,
    SpecialServiceDialog,
    CustomerInfoDialog,
    CellRenderDeleteIcon,
    CellHeaderAddIcon,
    CellRenderDateTimeInput,
  },
  props: {
    bookingRecord: {
      default: null
    },
    booker: {
      required: true
    },
    action: {
      required: true,
      default: 'create',
      validator: value => {
        return ['create', 'edit', 'view'].includes(value)
      }
    }
  },
  data() {
    return {
      dataKey: 0,
      context: null,
      loading: false,
      username: null,
      userid: null,
      has_breakfast: false,
      isSelectRowProfile: false,
      commentContent: '',
      isCustomerProfileDialogOpened: false,
      duplicateCustomer: null,

      vehicles: [],

      // new group contact info
      contact1: {
        fullname: '',
        // fax: '',
        email: '',
        order: 1,
        address_1: '',
        // address_2: '',
        phone_number: ''
      },
      contact2: {
        fullname: '',
        // fax: '',
        email: '',
        order: 2,
        address_1: '',
        // address_2: '',
        phone_number: ''
      },
      bookerFormData: {
        countryObject: null,
        id: null,
        name: null,
        phone: null,
        email: null,
        first_name: null,
        last_name: null
      },
      titleOptions: [
        { label: 'Mr', value: 'Mr' },
        { label: 'Ms', value: 'Ms' }
      ],

      // submit new group form

      form: {
        color: null,
        name: null,
        note: null,
        first_arrival_date: moment().format('YYYY-MM-DD'),
        last_departure_date: moment().add(1, 'd').format('YYYY-MM-DD'),
        numb_of_night: 1,
        agent_id: null,
        business_man_id: null,
        agent_id_2: null,
        debit_account_id: null,
        no_price_printing: true,
        no_extra_service: true,
        pay_method: null,
        vehicle: '',
        arriving_time: null,
        leaving_time: null,
        special_services: [],
        sub_booking_groups: [],
        market_seg_id: null,
        source_id: null,
        status: 1,
        contacts: [],
        comment: []
      },

      totalPage: 0,
      currentPage: 0,
      searchParamsAccount: {
        pageSize: 10,
        pageNum: 1,
        idCardOrVisa: null,
        email: null,
        address: null,
        phoneNumber: null,
        nationId: null,
        name: null
      },
      marketSegmentOptions: [],
      addParamsAccount: {
        idCardOrVisa: null,
        email: '',
        address: '',
        phoneNumber: '',
        nationId: '',
        name: ''
      },
      nationalityCols: [
        {
          headerName: this.$t('config.profile.select.nationalityCode'),
          field: 'code',
          tooltipField: 'code'
        },
        {
          headerName: this.$t('config.profile.select.nationalityName'),
          field: 'desc',
          tooltipField: 'desc'
        }
      ],
      nationalityRows: [],

      // dialog
      dialogVisible1: false,
      dialogVisible2: false,
      dialogVisible3: false,

      // select option
      agentOptions: [],
      debitAccountOptions: [],
      statusList: [
        { value: 1, name: 'Definite' },
        { value: 2, name: 'Tentative' },
        { value: 3, name: 'Seri Booking' },
        { value: 4, name: 'Waiting' }
      ],
      payMethodList: [
        { value: 1, name: 'Tiền mặt' },
        { value: 2, name: 'Công nợ' },
        { value: 3, name: 'Thẻ tín dụng' },
        { value: 4, name: 'Chuyển khoản' },
        { value: 5, name: 'VIP' },
        { value: 6, name: 'QR Code' },
        { value: 7, name: 'Khác' }
      ],
      sourceOptions: [],
      priceCodeOptions: [],
      breakfastCodeOptions: [],
      currencyOptions: [],

      // table colums and rows

      columnsSource: [
        {
          headerName: 'Mã nguồn',
          field: 'code',
          tooltipField: 'code',
          minWidth: 100,
          maxWidth: 150
        },

        {
          headerName: 'Mô tả',
          field: 'desc',
          tooltipField: 'desc',
          flex: 1
        }
      ],

      columnsAgent: [
        {
          headerName: 'Tên công ty, đại lý du lịch',
          field: 'name',
          tooltipField: 'name',
          // minWidth: 200
          flex: 1
        }
      ],
      columnsDebitAccount: [
        {
          headerName: 'Tài khoản',
          field: 'name',
          tooltipField: 'name',
          minWidth: 100,
          maxWidth: 150
        }
      ],
      columns: [
        {
          headerName: 'Hạng phòng',
          field: 'room_level_code',
          tooltipField: 'room_level_code',
          minWidth: 150
        },
        {
          headerName: 'Phòng trống',
          field: 'room_available_num',
          tooltipField: 'room_available_num',
          minWidth: 100
        },
        {
          headerName: 'Từ ngày',
          field: 'date_from',
          // tooltipField: 'account_num',
          cellClass: 'grid-cell-align-center',
          // cellEditor: 'agDateStringCellEditor',
          // valueFormatter: params => {
          //   if (!params.value) {
          //     return ''
          //   }
          //   var cellDate = this.$moment(params.value, 'YYYY-MM-DD').toDate()
          //   const month = cellDate.getMonth() + 1
          //   const day = cellDate.getDate()
          //   return `${cellDate.getFullYear()}-${
          //     month < 10 ? '0' + month : month
          //   }-${day < 10 ? '0' + day : day}`
          // },
          // cellEditor: 'CellRenderCalendarSelect',
          // editable: true,
          // cellDataType: 'date'
          cellRenderer: 'CellRenderCalendarSelectForTable',
          cellRendererParams: () => {
            return {
              type: 'text',
              colName: 'date_from',
              date: {
                min: this.form.first_arrival_date,
                max: this.form.last_departure_date
              }
            }
          },
          minWidth: 155,
          maxWidth: 155
        },
        {
          headerName: 'Đến ngày',
          field: 'date_to',
          cellClass: 'grid-cell-align-center',
          cellRenderer: 'CellRenderCalendarSelectForTable',
          cellRendererParams: () => {
            return {
              type: 'text',
              colName: 'date_to',
              date: {
                min: this.form.first_arrival_date,
                max: this.form.last_departure_date
              }
            }
          },
          minWidth: 155,
          maxWidth: 155
        },
        {
          headerName: 'SL phòng',
          field: 'num_of_room',
          cellClass: 'grid-cell-align-center',
          cellRenderer: 'CellRenderNumInput',
          cellRendererParams: () => {
            return {
              type: 'number',
              colName: 'num_of_room'
            }
          },
          minWidth: 100
        },
        {
          headerName: 'Số khách',
          field: 'num_of_guest',
          cellClass: 'grid-cell-align-center',
          cellRenderer: 'CellRenderNumInput',
          cellRendererParams: params => {
            return {
              value: this.rows[params?.rowIndex].num_of_guest
                ? this.rows[params?.rowIndex].num_of_guest
                : null,
              type: 'number',
              colName: 'num_of_guest'
            }
          },
          minWidth: 100
        },

        {
          headerName: 'Buffet',
          field: 'isBf',
          cellClass: 'grid-cell-align-center',
          cellRenderer: 'CellRenderCheckbox',
          cellRendererParams: params => {
            return {
              // value: params.data.hotel_id != 45 ? true : false,
              type: 'text',
              colName: 'isBf',
              disabled: false,
              hotel_id: params.data.hotel_id
            }
          },
          minWidth: 80,
          maxWidth: 100
        },

        {
          headerName: 'NETT',
          field: 'nett',
          cellClass: 'grid-cell-align-center',
          cellRenderer: 'CellRenderCheckbox',
          cellRendererParams: params => {
            return {
              value: true,
              type: 'text',
              colName: 'nett',
              disabled: !params.data.self_price
            }
          },
          minWidth: 80,
          maxWidth: 100
        }
      ],
      rows: [],

      columnsTraveller: [
        {
          headerName: 'Mã hồ sơ',
          field: 'code',
          tooltipField: 'code',
          cellStyle: params => {
            // if(params.value === 0) return {}
          },
          minWidth: 130,
          maxWidth: 150
        },
        {
          headerName: 'Họ',
          field: 'last_name',
          tooltipField: 'last_name',
          minWidth: 100,
          maxWidth: 110
        },
        {
          headerName: 'Tên',
          field: 'first_name',
          tooltipField: 'first_name',
          minWidth: 100,
          maxWidth: 110
        },

        {
          headerName: 'Giới tính',
          field: 'sex',
          tooltipField: 'sex',
          valueGetter: params => {
            if (params?.data?.sex == 1) return 'Nam'
            if (params?.data?.sex == 2) return 'Nữ'
          },
          minWidth: 100,
          maxWidth: 100
        },
        {
          headerName: 'Ngày sinh',
          field: 'birth',
          // tooltipField: 'birth',
          cellRenderer: params => {
            return params.value
              ? this.$moment(params.value).format('DD-MM-YYYY')
              : null
          },
          tooltipValueGetter: params => {
            return params.value
              ? this.$moment(params.value).format('DD-MM-YYYY')
              : null
          },
          minWidth: 120,
          maxWidth: 120
        },
        {
          headerName: 'Quốc tịch',
          field: 'nationality',
          tooltipField: 'nationality',
          minWidth: 100
        },
        {
          headerName: 'Hộ chiếu/Thẻ căn cước',
          headerTooltip: 'Hộ chiếu/Thẻ căn cước',
          field: 'id_card',
          tooltipField: 'id_card',
          minWidth: 150
        },

        {
          headerName: 'Số điện thoại',
          headerTooltip: 'Số điện thoại',
          field: 'phone_number',
          tooltipField: 'phone_number',
          minWidth: 120
        },
        {
          headerName: 'Email',
          field: 'email',
          tooltipField: 'email',
          minWidth: 120
        },
        {
          headerName: 'Địa chỉ',
          field: 'address_1',
          minWidth: 100,
          tooltipField: 'address_1',
          flex: 1
        }
      ],
      rowsTraveller: [],
      columnsTransaction: [
        {
          headerName: 'Mã',
          minWidth: 100,
          field: 'code',
          tooltipField: 'code',
          cellStyle: params => {
            // if(params.value === 0) return {}
          }
        },
        {
          headerName: 'Tên',
          minWidth: 100,
          field: 'desc',
          tooltipField: 'desc'
        },
        {
          headerName: 'Giá đơn vị',
          headerTooltip: 'Giá đơn vị',
          minWidth: 100,
          field: 'price',
          // tooltipField: 'price',
          cellRenderer: params => {
            return params.value !== null
              ? params.value.toLocaleString('en-US')
              : null
          },
          tooltipValueGetter: params => {
            return params.value !== null
              ? params.value.toLocaleString('en-US')
              : null
          },
          cellClass: 'grid-cell-right'
        },
        {
          headerName: 'Số lượng',
          minWidth: 100,
          field: 'quantity',
          tooltipField: 'quantity'
        },
        {
          headerName: 'Từ ngày',
          minWidth: 100,
          field: 'service_start_date',
          tooltipField: 'service_start_date'
        },
        {
          headerName: 'Đến ngày',
          minWidth: 100,
          field: 'service_end_date',
          tooltipField: 'service_end_date'
        },
        // {
        //   headerName: 'Mở',
        //   field: 'open_fee',
        //   cellRenderer: 'CellRenderCheckboxReadonly'
        // },
        // {
        //   headerName: 'Tiền tệ',
        //   field: 'currency'
        // },
        {
          headerName: 'Nhân viên',
          field: 'employee_name',
          tooltipField: 'employee_name'
        },
        {
          headerName: 'Ghi chú',
          field: 'note',
          tooltipField: 'note'
        }
      ],
      rowsTransaction: []
    }
  },
  watch: {
    booker: {
      handler() {
        this.bookerFormData.id = this.booker.id
        this.bookerFormData.name = this.booker.name
        this.bookerFormData.phone = this.booker.phone
        this.bookerFormData.email = this.booker.email
        this.bookerFormData.first_name = this.booker.first_name
        this.bookerFormData.last_name = this.booker.last_name
      },
      deep: true
    }
  },
  created() {
    // this.fnGetConfirmCodeApi()
    this.getTraveller()
    this.getListAgent()
    this.getMarketSegmentOptions()
    this.getListSource()
    this.getListBreakfastCode()
    this.getCurrencyList()

    if (this.booker != null) {
      this.bookerFormData = this.booker
    }
    if (this.bookingRecord != null) {
      this.form = { ...this.bookingRecord }
      this.contact1 = { ...this.form.contacts[0] }
      this.contact2 = { ...this.form.contacts[1] }
    }
  },
  beforeMount() {
    this.context = { componentParent: this }
    this.vehicles = (this.bookingRecord?.vehicles ?? []).map(vehicle => ({
      ...JSON.parse(JSON.stringify(vehicle)),
      vehicle_name: 'Ô tô'
    }))
  },
  async mounted() {
    this.getUserInfo()
    this.getSubGroup()
    this.fnGetDebitAccByAgent()
    this.nationalityRows = await getAllNationality()
  },
  watch: {
    // 'form.agent_id'() {
    //   this.form.market_seg_id = this.agentOptions.filter(
    //     item => (item.id = this.form.agent_id)
    //   )[0].market_seg_id
    //   this.form.source_id = this.agentOptions.filter(
    //     item => (item.id = this.form.agent_id)
    //   )[0].source_id
    //   this.fnGetDebitAccByAgent(this.form.agent_id)
    // },
    arriveAndDepartDate() {
      let dateArrival = moment(this.form.first_arrival_date)
      let dateDeparture = moment(this.form.last_departure_date)
      let daysDistance = dateDeparture.diff(dateArrival, 'days')
      if (daysDistance == 0) {
        this.form.numb_of_night = 1
      } else {
        this.form.numb_of_night = daysDistance
      }
      this.getSubGroup()
    },
    arriveAndDepartTime() {
      let timeArrival = moment(this.form.arriving_time)
      let timeDeparture = moment(this.form.leaving_time)
      let timeDistance = timeDeparture.diff(timeArrival, 'minutes')
      if (timeDistance <= 0) {
        this.form.leaving_time = timeArrival
          .add(1, 'd')
          .format('YYYY-MM-DD HH:mm:ss')
        // this.$vxAlert('Thời gian đến không hợp lệ.')
      } else {
      }
    }
  },
  computed: {
    marketSegCode() {
      return this.form.agent_id
        ? this.agentOptions.filter(item => item.id === this.form.agent_id)[0]
            .market_seg_code
        : ''
    },
    isBookerSelected() {
      return this.bookerFormData.id != null
    },
    sourceCode() {
      return this.form.agent_id
        ? this.agentOptions.filter(item => item.id === this.form.agent_id)[0]
            .source_code
        : ''
    },
    arriveAndDepartDate() {
      return [this.form.first_arrival_date, this.form.last_departure_date]
    },
    arriveAndDepartTime() {
      return [this.form.arriving_time, this.form.leaving_time]
    },
    vehicleCols() {
      return [
        {
          headerName: 'Tên phương tiện',
          field: 'vehicle_name',
          flex: 2,
          minWidth: 100
        },
        {
          headerName: 'Biển kiểm soát',
          field: 'license_plate',
          flex: 2,
          // cellClass: 'grid-cell-centered',
          minWidth: 100,
          cellRenderer: 'CellRenderTextInput2',
          cellRendererParams: () => {
            return {
              type: 'text',
              colName: 'license_plate'
            }
          }
        },
        {
          headerName: 'Thời gian đến',
          field: 'arrive_time',
          flex: 2,
          // cellClass: 'grid-cell-centered',
          minWidth: 100,
          cellRenderer: 'CellRenderDateTimeInput',
          cellRendererParams: data => {
            return {
              type: 'text',
              colName: 'arrive_time',
              clearable: true,
              dateType: 'datetime',
              format: 'dd/MM/yyyy HH:mm:ss',
              valueFormat: 'yyyy-MM-dd HH:mm:ss'
            }
          }
        },
        {
          headerName: 'Thời gian đi',
          field: 'depart_time',
          flex: 2,
          // cellClass: 'grid-cell-centered',
          minWidth: 100,
          cellRenderer: 'CellRenderDateTimeInput',
          cellRendererParams: data => {
            return {
              type: 'text',
              colName: 'depart_time',
              clearable: true,
              dateType: 'datetime',
              format: 'dd/MM/yyyy HH:mm:ss',
              valueFormat: 'yyyy-MM-dd HH:mm:ss'
            }
          }
        },
        {
          headerName: '',
          width: 50,
          cellRenderer: 'CellRenderDeleteIcon',
          headerComponent: 'CellHeaderAddIcon',
          cellStyle: () => {
            return {
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center'
            }
          }
        }
      ]
    }
  },
  methods: {
    validateVehicleFormData() {
      for (let i = 0; i < this.vehicles.length; i++) {
        if (
          this.vehicles[i].vehicle_name == null ||
          this.vehicles[i].vehicle_name == '' ||
          this.vehicles[i].license_plate == null ||
          this.vehicles[i].license_plate == '' ||
          this.vehicles[i].arrive_time == null ||
          this.vehicles[i].arrive_time == '' ||
          this.vehicles[i].depart_time == null ||
          this.vehicles[i].depart_time == ''
        ) {
          if (
            this.vehicles[i].vehicle_name == null ||
            this.vehicles[i].vehicle_name == ''
          ) {
            return this.$t('validation.required', {
              field: 'tên phương tiện'
            })
          }
          if (
            this.vehicles[i].license_plate == null ||
            this.vehicles[i].license_plate == ''
          ) {
            return this.$t('validation.required', {
              field: 'biển kiểm soát'
            })
          }
          if (
            this.vehicles[i].arrive_time == null ||
            this.vehicles[i].arrive_time == ''
          ) {
            return this.$t('validation.required', {
              field: 'thời gian đến của xe'
            })
          }
          if (
            this.vehicles[i].depart_time == null ||
            this.vehicles[i].depart_time == ''
          ) {
            return this.$t('validation.required', {
              field: 'thời gian đi của xe'
            })
          }
        }
      }
      return null
    },
    checkValidDateRange(dateFrom, dateTo) {
      if (dateFrom && dateTo && dateFrom >= dateTo) {
        return false
      }
      return true
    },

    changeDateTime(params, value, colName) {
      const idx = params.rowIndex
      this.vehicles[idx][colName] = value
    },

    onAddRowInGrid() {
      this.vehicles.unshift({
        vehicle_name: 'Ô tô',
        license_plate: null,
        arrive_time: null,
        depart_time: null
      })
      console.log(this.vehicles)
    },

    onDeleteIconClicked(data) {
      const idx = data.rowIndex
      this.vehicles.splice(idx, 1)
    },
    textInputChange2(params, data, colName) {
      this.vehicles[params.node.rowIndex][colName] = data
    },

    onChangeDateFrom(date) {
      this.form.first_arrival_date = date
      if (!this.checkValidDateRange(date, this.form.last_departure_date)) {
        setTimeout(() => {
          this.form.last_departure_date = this.$moment(
            this.form.first_arrival_date
          )
            .add(1, 'd')
            .format('YYYY-MM-DD')
        })
      }
    },

    onChangeDateTo(date) {
      this.form.last_departure_date = date

      if (!this.checkValidDateRange(this.form.first_arrival_date, date)) {
        setTimeout(() => {
          this.form.last_departure_date = this.$moment(
            this.form.first_arrival_date
          )
            .add(1, 'd')
            .format('YYYY-MM-DD')
        })
      }
    },
    async getMarketSegmentOptions() {
      await getMarketSegmentApi({
        isActive: 1
      }).then(response => {
        this.marketSegmentOptions = response.data
      })
    },
    onCountryChanged(countryObject) {
      this.bookerFormData.countryObject = countryObject
    },
    onOpenSelectBookerDialog() {
      this.dialogVisible1 = true
    },
    onRemoveBooker() {
      this.bookerFormData.id = null
      this.bookerFormData.name = null
      this.bookerFormData.first_name = null
      this.bookerFormData.last_name = null
      this.bookerFormData.phone = null
      this.bookerFormData.email = null
    },
    onSelectDuplicateCustomer() {
      this.bookerFormData.id = this.duplicateCustomer.id
      this.bookerFormData.name = this.duplicateCustomer.name
      this.bookerFormData.first_name = this.duplicateCustomer.first_name
      this.bookerFormData.last_name = this.duplicateCustomer.last_name
      this.bookerFormData.phone = this.duplicateCustomer.phone_number
      this.bookerFormData.email = this.duplicateCustomer.email
      this.isCustomerProfileDialogOpened = false
    },
    async findDuplicateTraveller(phone, number) {
      await findDuplicateTraveller(null, phone, number)
        .then(response => {
          if (response?.data == null) {
            notifyError('customerNotFound')
            return
          }
          this.duplicateCustomer = response?.data
          this.isCustomerProfileDialogOpened = true
        })
        .catch(() => {
          notifyError('customerNotFound')
        })
    },
    async onSearchDuplicateCustomer() {
      if (
        this.bookerFormData.first_name == null ||
        this.bookerFormData.phone == null ||
        this.bookerFormData.id != null
      ) {
        return
      }
      await this.findDuplicateTraveller(
        this.bookerFormData.first_name,
        this.bookerFormData.phone
      )
    },

    changeColor(val) {
      // this.form.color = val
    },
    clsAlphaNoOnly(e) {
      // Accept only alpha numerics, no special characters
      let regex = new RegExp('^[a-zA-Z0-9 ]+$')
      let str = String.fromCharCode(!e.charCode ? e.which : e.charCode)
      if (regex.test(str)) {
        return true
      }

      e.preventDefault()
      return false
    },

    async onPageChanged(pageNum) {
      this.searchParamsAccount.pageNum = pageNum
      await this.getTraveller()
    },

    async getTraveller() {
      const data = await getTravellerListApi(this.searchParamsAccount)
      this.rowsTraveller = data.data
      this.totalPage = Math.ceil(data.total / this.searchParamsAccount.pageSize)
      this.currentPage = data.data?.length == 0 ? 0 : data.page_num
    },
    onSelectNation(data) {
      this.searchParamsAccount.nationId = data?.id || null
    },
    async getCurrencyList() {
      let data = await getCurrencyListSimpleApi()
      this.currencyOptions = data.data
    },
    async fnGetDebitAccByAgent() {
      const data = await getDebitAccByAgent({ agentId: this.form.agent_id })
      this.debitAccountOptions = data.data
    },
    async getSubGroup() {
      let data = await getRoomAvaiSubGroupApi({
        dateFrom: `${this.form.first_arrival_date} 14:00`,
        dateTo: `${this.form.last_departure_date} 12:00`
        // priceCodeId: this.form.price_code_id
      })
      this.rows = [
        ...data.data.map((item, index) => {
          if (item?.hotel_id == 45)
            return { ...item, self_price: false, id: index, isBf: false }
          else return { ...item, self_price: false, id: index, isBf: true }
        })
      ]
    },
    async fnGetRoomRowApi(params, index) {
      await getRoomRowApi(params)
        .then(res => {
          Object.assign(this.rows[index], {
            ...res.data,
            self_price: false,
            id: index
          })
        })
        .finally(() => {
          this.$refs.agGrid.gridOptions.api.refreshCells({
            force: true
          })
        })
    },

    onClickRowTraveller(row) {
      this.isSelectRowProfile = true
    },

    async onPageSizeChange(pageSize) {
      this.searchParamsAccount.pageSize = pageSize
      this.searchParamsAccount.pageNum = 1
      await this.getTraveller()
    },
    async getListBreakfastCode() {
      let data = await getBreakfastCodeListApi()
      this.breakfastCodeOptions = data.data
    },
    async getListPriceCode() {
      let data = await getPriceCodeApi({
        dateFrom: this.form.first_arrival_date,
        dateTo: this.form.last_departure_date
      })
      this.priceCodeOptions = data.data
    },
    async getListSource() {
      let data = await getSourceApi({ isActive: 1 })
      this.sourceOptions = data.data
    },
    async getListAgent() {
      let data = await getAgent({ sourceId: this.form.source_id })
      // getAgent
      this.agentOptions = data?.data
    },
    assignProfile() {
      const gridApi = this.$refs.agGridProfile.gridApi
      const rowsSelected = gridApi.getSelectedRows()
      this.bookerFormData.last_name = rowsSelected[0]?.last_name
      this.bookerFormData.first_name = rowsSelected[0]?.first_name
      this.bookerFormData.name = rowsSelected[0]?.name
      this.bookerFormData.id = rowsSelected[0]?.id
      this.bookerFormData.phone = rowsSelected[0]?.phone_number
      this.bookerFormData.email = rowsSelected[0]?.email
      this.onReset()
      this.getTraveller()
      this.dialogVisible1 = false
    },

    confirmSpecialService(val) {
      this.form.special_services = val
      this.$refs.agGridService.gridOptions.api.refreshCells({
        force: true
      })
    },

    // sub group
    SelectInputChange(colName, data, value) {
      const idx = data.rowIndex
      this.rows[idx][colName] = value
    },
    textInputChange(params, value, colName) {
      const idx = params.rowIndex
      this.rows[idx][colName] = value
      if (value == 0) {
        this.rows[idx][colName] = ''
      }
      if (value != 0 && colName == 'num_of_room') {
        if (value > this.rows[idx].room_available_num) {
          this.$message({
            type: 'error',
            message: 'Số phòng vượt quá số phòng có sẵn'
          })
          this.rows[idx].num_of_room = ''
          this.rows[idx].num_of_guest = ''
          this.$refs.agGrid.gridOptions.api.refreshCells({
            force: true
          })
          return
          // this.rows[idx][colName] = ''
        }
        this.rows[idx].num_of_guest = value * params?.data?.people_num
      }
      this.$refs.agGrid.gridOptions.api.refreshCells({
        force: true
      })
    },
    changeCurrencyInput(params, value, colName) {
      const idx = params.rowIndex
      this.rows[idx][colName] = value
    },
    changeCalendar(params, value, colName) {
      const idx = params.rowIndex
      this.rows[idx][colName] = value
      this.fnGetRoomRowApi(
        {
          roomLevel: params.data.room_level_id,
          dateFrom: `${this.$moment(params.data.date_from, 'YYYY-MM-DD').format(
            'YYYY-MM-DD'
          )} 14:00`,
          dateTo: `${this.$moment(params.data.date_to, 'YYYY-MM-DD').format(
            'YYYY-MM-DD'
          )} 12:00`
        },
        idx
      )
    },

    changeCheckbox(colName, params, value) {
      const idx = params.rowIndex

      this.rows[idx][colName] = value
    },
    //

    async addComment() {
      if (
        (await this.$vxForm.isValid(this.$refs.commentFormValidator)) === false
      ) {
        return
      }
      if (this.commentContent != '') {
        this.form.comment.push({
          content: this.commentContent,
          create_user_id: this.userid,
          create_date: this.$moment().format('YYYY-MM-DD'),
          isEdit: false
        })
        this.commentContent = ''
      }
    },
    deleteComment(index) {
      this.form.comment = this.form.comment
        .slice(0, index)
        .concat(this.form.comment.slice(index + 1))
    },

    async onSelectRowAgent(val) {
      if (val) {
        this.form.agent_id = val.id
        this.form.source_id = val.source_id
        this.form.market_seg_id = val.market_seg_id
        await this.fnGetDebitAccByAgent(this.form.agent_id)
        this.form.debit_account_id =
          this.debitAccountOptions.length > 0
            ? this.debitAccountOptions[0].id
            : null
      } else {
      }
    },

    onSelectDebitAccount(val) {
      this.form.debit_account_id = val?.id
    },
    onSelectRowSource(val) {
      this.form.source_id = val?.id
      this.getListAgent()
      this.form.agent_id = null
      this.form.market_seg_id = null
    },

    async validateBookerFormData() {
      if ((await this.$vxForm.isValid(this.$refs.formValidator)) == false)
        return 0
      return 1
    },
    dehydrateFormData() {
      let arrayContact = []
      if (
        this.contact1.fullname ||
        this.contact1.email ||
        this.contact1.address_1 ||
        this.contact1.phone_number
      ) {
        arrayContact.push(this.contact1)
      }
      if (
        this.contact2.fullname ||
        this.contact2.email ||
        this.contact2.address_1 ||
        this.contact2.phone_number
      ) {
        arrayContact.push(this.contact2)
      }
      this.form.contacts = [...arrayContact]

      let flagReturn = false
      let arraySubGroup = this.rows.filter(
        it => it.num_of_room || it.num_of_guest
      )
      arraySubGroup.map(it => {
        it.date_from = this.$moment(it.date_from).format('YYYY-MM-DD HH:mm')
        it.date_to = this.$moment(it.date_to).format('YYYY-MM-DD HH:mm')
      })
      //  || it.price || it.currency_id
      arraySubGroup.forEach(subGroup => {
        if (
          !subGroup.num_of_guest ||
          !subGroup.num_of_room ||
          !subGroup.price
        ) {
          flagReturn = true

          // return
        }
      })
      if (flagReturn) {
        this.$message({
          type: 'error',
          message: this.$t('errorMsg.fillSubGroup')
        })
        return null
      }
      this.form.sub_booking_groups = [...arraySubGroup]
      this.form.vehicles = this.vehicles.map(vehicle => ({
        ...JSON.parse(JSON.stringify(vehicle)),
        vehicle_name: 'Ô tô'
      }))
      // if (true) {
      //   alert('add group thanh cong!!')
      //   return
      // }
      this.form.booker = { ...this.bookerFormData }
      delete this.form.deposit
      // this.form.first_arrival_date = this.$moment(
      //   this.form.first_arrival_date
      // ).format('DD-MM-YYYY')
      // this.form.last_departure_date = this.$moment(
      //   this.form.last_departure_date
      // ).format('DD-MM-YYYY')
      const payload = JSON.parse(JSON.stringify(this.form))
      return payload
    },

    onReset() {
      this.searchParamsAccount = {
        pageSize: 10,
        pageNum: 1,
        idCardOrVisa: null,
        email: null,
        address: null,
        phoneNumber: null,
        nationId: null,
        name: null
      }
    },
    addProfileTraveller() {
      // this.dialogVisible1 = false
      // this.dialogVisible3 = true
      let resolvedRoute = this.$router.resolve({
        path: '/configuration/profile/customer'
      })
      window.open(resolvedRoute.href, '_blank')
    },

    openRegisAgent() {
      let resolvedRoute = this.$router.resolve({
        path: '/configuration/profile/company'
      })
      window.open(resolvedRoute.href, '_blank')
      // this.$router.push({ path: '/configuration/profile/company' })
    },
    async getUserInfo() {
      let data = await getUserDetailApi()
      this.username = data.data?.user?.full_name
      this.userid = data.data?.user?.id
    }
  },
  directives: {
    focus: {
      inserted(el) {
        el.focus()
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.comments {
  .add-comment {
  }
  .comments-list {
    .comment-item {
    }
  }
}
.comments-scroll {
  overflow: scroll;
}
.contact-address {
  display: flex;
  justify-content: space-between;
  // gap: 20px;
  .section-box {
    margin-top: 20px !important;
    width: 32%;
    // height: 500px;
    // flex-shrink: 1 !important;
    .comment-container {
      position: relative;
      margin-top: 10px;
      padding: 15px;
      border-radius: 5px;
      font-size: 14px;
      background: #f0f0f5;
      p {
        margin: 0;
        margin-bottom: 15px;
      }
      .comment-content {
        display: flex;
        width: 100%;
        p {
          margin: 0;
          overflow: hidden;
          // width: calc(100% - 70px);
        }
        p:first-child {
          margin-right: 10px;
          overflow: none !important;
          min-width: 70px;
        }
        input {
          padding: 0;
          padding: 2px;
        }
      }
      input {
        padding: 24px;
      }
      .input-pen-icon {
        position: absolute;
        top: 8px;
        right: 45px;
      }
      .input-delete-icon {
        position: absolute;
        top: 8px;
        right: 10px;
      }
    }
    .input-comment {
      position: relative;
      margin-top: 10px;
      input {
        padding: 24px;
      }
      span {
        position: absolute;
        top: 8px;
        right: 10px;
      }
    }
    span {
      // position: absolute;
      top: 0;
    }
  }
}

.header-form {
  margin-top: 10px;
  display: flex;
  align-items: center;
  gap: 10px;
  justify-content: space-between;
  background: #f5f6fc;

  .title-form {
    height: 40px;
    display: flex;
    align-items: center;
  }
}
// .ag-theme-balham .ag-row-selected {
//   background-color: #357456 !important;
// }
.mb-2 {
  margin-bottom: 8px;
}
.section-box {
  height: fit-content !important;
}
.has-breakfast {
  font-weight: 700 !important;
  color: #606266 !important;
  font-size: 14px !important;
}

.room-list::v-deep .ag-cell {
  overflow: visible !important;
  // .vc-popover-content-wrapper.is-interactive {
  //   position: fixed !important;
  //   inset: unset !important;
  //   transform: translate(0px, 0px) !important;
  // }
}
.room-list::v-deep .ag-row-focus {
  z-index: 1;
}

// .room-list >>> .ag-center-cols-viewport,
// .room-list >>> .ag-center-cols-clipper,
// .room-list >>> .ag-layout-normal {
//   overflow: visible !important;
// }

.room-list::v-deep .el-input__inner {
  height: 24px !important;
}
.title-required {
  position: relative;
  &::before {
    content: '*';
    font-size: 15px;
    color: red;
    width: 5px;
    height: 5px;
    position: absolute;
    top: 0;
    right: -8px;
  }
}
</style>
